import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChangePasswordComponent } from '@app/core/change-password/change-password.component';
import { PartnerComponent } from '@app/core/partner/partner.component';
import { PasswordRecoveryComponent } from '@app/core/password-recovery/password-recovery.component';
import { PaymentSuccessComponent } from '@app/core/payment-success/payment-success.component';
import { RegistrationComponent } from '@app/core/registration/registration.component';
import { ServerMaintenanceComponent } from '@app/core/server-maintenance/server-maintenance.component';
import { UserSignupComponent } from '@app/core/user-signup/user-signup.component';
import { NewUserGuard } from '@app/guard/new-user.guard';
import { ClickarPath } from '@shared/clickar-constants';

const routes: Routes = [
	{
		path: ClickarPath.PARTNER,
		component: PartnerComponent,
		canActivate: []
	},
	{
		path: ClickarPath.REGISTRATION,
		component: RegistrationComponent
	},
	{
		path: ClickarPath.CHANGE_PASSWORD,
		component: ChangePasswordComponent,
		canActivate: []
	},
	{
		path: ClickarPath.PASSWORD_RECOVERY,
		component: PasswordRecoveryComponent,
		canActivate: []
	},
	{
		path: ClickarPath.USER_SIGNUP,
		component: UserSignupComponent,
		canActivate: [NewUserGuard],
		canActivateChild: [NewUserGuard]
	},
	{
		path: ClickarPath.PAYMENT_SUCCESS,
		component: PaymentSuccessComponent,
		canActivate: []
	},
	/* {
		path: ClickarPath.PAYMENT_FAILURE,
		component: PaymentFailureComponent,
		canActivate: []
	}, */
	{
		path: ClickarPath.SERVER_MAINTENANCE,
		component: ServerMaintenanceComponent,
		canActivate: []
	}

];

@NgModule({
	imports: [
		RouterModule.forChild(routes)
	],
	exports: [
		RouterModule
	],
	providers: []
})
export class CoreRouterModule { }